import React from 'react';
import { Typography, Stack } from '@mui/material';

interface Props {
  number?: string;
  text?: string;
}

export const ListText: React.FC<Props> = props => {
  return (
    <Stack direction="row" mb={2}>
      <Typography
        variant="h1"
        component="p"
        mr={1}
        sx={{ marginBottom: '0rem', color: 'primary.red' }}
      >
        {props.number}
      </Typography>
      <Typography
        variant="h5"
        component="p"
        sx={{
          marginBottom: '0rem',
          marginTop: '1.75rem',
          display: 'table-cell',
          verticalAlign: 'center',
        }}
      >
        {props.text}
      </Typography>
    </Stack>
  );
};
